import { useMemo, useCallback } from 'react';
import Calendar, { TileDisabledFunc } from 'react-calendar';
// import { twMerge } from 'tailwind-merge';
// import { ReserveData, useReserveData } from '../../_context/reserve';
import {
  addDays,
  addMonths,
  isBefore,
  isAfter,
  format,
  getYear,
} from 'date-fns';
import './style.css';

// components
import MDBox from "components/MDBox";

// css
import 'css/calendar.css';

interface VerticalCalendarProps {
  endDate: string;
  setIsCalendar: ( bool: boolean ) => void;
  handleInputDescription: (newDate: string, type: 'date') => void;
}

type MonthData = {
  date: Date;
  name: string;
  year: number;
};

const VerticalCalendar: React.FC<VerticalCalendarProps> = ({ endDate, setIsCalendar, handleInputDescription }) => {
  // const { data, setData } = useReserveData();

  const displayedMonths = useMemo<MonthData[]>(() => {
    let startingDate = addDays(new Date(), 1);
    const endingDate = addMonths(new Date(endDate), 1);
    const monthData: MonthData[] = [];

    while (isBefore(startingDate, endingDate)) {
      monthData.push({
        date: startingDate,
        name: format(startingDate, 'MMMM'),
        year: getYear(startingDate),
      });
      startingDate = addMonths(startingDate, 1);
    }
    return monthData;
  }, [endDate]);

  // Zakázanie dní pred zajtrajškom a dní po endDate
  const disableTile = useCallback<TileDisabledFunc>(
    ({ date }: any) =>
      isBefore(date, addDays(new Date(), 1)) || isAfter(date, new Date(endDate)),
    [endDate],
  );

  return (
    <MDBox 
      sx={{
        height: '40dvh',
        overflowY: 'auto',
        paddingBottom: '0.75rem',
        padding: '1rem',    
        scrollbarWidth: 'none',  
        msOverflowStyle: 'none',
        borderRadius: "0.75rem",
        backgroundColor: "#fff",
        zIndex:"1301",
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        '@media (min-height: 800px)': {
          height: '30dvh',
        },
      }}
    >
      {displayedMonths.map((month: MonthData) => (
        <div
          key={month.name}
          style={{
            display: "flex", flexDirection: "column", gap: "0.5rem",
          }}
        >
          <span
            style={{
              fontSize: "1.3rem",
            }}
          >{month.name}</span>
          <Calendar
            tileDisabled={disableTile}
            activeStartDate={month.date}
            className="kajaky-calendar"
            formatDay={(_locale, date) => format(date, 'd')}
            onChange={(value) => {
              handleInputDescription(format(value as Date, "dd.MM.yyyy"), "date");
              setIsCalendar(false);
            }}            
            // value={data?.date}
          />
        </div>
      ))}
    </MDBox>
  );
};

export default VerticalCalendar;
